import apiClient from '../authentication/utils/core/axios';

// Server-side analytics logging for the small, deliberately-scoped
// instrumentation set (session_start, group_join, group_cancel,
// prediction_viewed, prediction_followed, notification_opened,
// leaderboard_viewed). Backend-native events are logged directly at their
// real backend call sites; this covers the frontend-observed "view" events.
// Fire-and-forget by design -- a failed analytics call must never surface to
// the user or block the UI action it's attached to.
export const logAnalyticsEvent = (eventType, metadata = null) => {
  apiClient
    .post('/analytics/events', { event_type: eventType, metadata })
    .catch(() => {
      // Deliberately silent -- analytics must never break the real feature.
    });
};
